"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getChangedInputTime = exports.checkForTimeFormat = exports.getChangedTime = exports.getType = exports.chunkArray = exports.isEmptyObject = exports.isSameMonth = exports.compareDates = void 0;

var _constants = require("./constants");

var DATE = _constants.types.DATE,
    TIME = _constants.types.TIME,
    DATETIME = _constants.types.DATETIME;

var compareDates = function compareDates(date1, date2) {
  return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
};

exports.compareDates = compareDates;

var isSameMonth = function isSameMonth(date1, date2) {
  return date1.getMonth() === date2.getMonth();
};

exports.isSameMonth = isSameMonth;

var isEmptyObject = function isEmptyObject(obj) {
  return Object.entries(obj).length === 0;
};

exports.isEmptyObject = isEmptyObject;

var chunkArray = function chunkArray(items, length) {
  var chunks = [];
  var chunk = [];

  for (var i = 0; i < items.length; i += 1) {
    chunk.push(items[i]);

    if (chunk.length === length) {
      chunks.push(chunk);
      chunk = [];
    }
  }

  return chunks;
};

exports.chunkArray = chunkArray;

var getType = function getType(format, type) {
  if (type) {
    return type;
  }

  if (!format) {
    return DATETIME;
  }

  var isDate = format.year || format.month || format.day;
  var isTime = format.hour || format.minute || format.second || format.millisecond;

  if (isDate && !isTime) {
    return DATE;
  }

  if (!isDate && isTime) {
    return TIME;
  }

  return DATETIME;
};

exports.getType = getType;

var shiftTime = function shiftTime(_ref) {
  var value = _ref.value,
      increment = _ref.increment,
      boundaries = _ref.boundaries;

  if (increment > 0 && value === boundaries[1]) {
    return boundaries[0];
  }

  if (increment < 0 && value === boundaries[0]) {
    return boundaries[1];
  }

  return value + increment;
};

var shiftHourTime = function shiftHourTime(_ref2) {
  var value = _ref2.value,
      increment = _ref2.increment;
  var currentHours = value.getHours();

  if (increment === 1) {
    if (currentHours === 23) {
      return 12;
    }

    if (currentHours === 11) {
      return 0;
    }
  } else if (increment === -1) {
    if (currentHours === 12) {
      return 23;
    }

    if (currentHours === 0) {
      return 11;
    }
  }

  return value.getHours() + increment;
};

var getChangedTime = function getChangedTime(_ref3) {
  var value = _ref3.value,
      type = _ref3.type,
      increment = _ref3.increment,
      localeFormat = _ref3.localeFormat;

  var _checkForTimeFormat = checkForTimeFormat(localeFormat),
      isAmPm = _checkForTimeFormat.isAmPm,
      hourStartsWithZero = _checkForTimeFormat.hourStartsWithZero;

  var result = new Date(value);
  var hourBoundaries = hourStartsWithZero ? [0, 23] : [1, 24];

  if (isAmPm) {
    hourBoundaries = [1, 12];
  }

  if (type === 'hours') {
    if (isAmPm) {
      result.setHours(shiftHourTime({
        value: value,
        increment: increment
      }));
    } else {
      result.setHours(shiftTime({
        value: value.getHours(),
        increment: increment,
        boundaries: hourBoundaries
      }));
    }
  }

  if (type === 'minutes') {
    result.setMinutes(shiftTime({
      value: value.getMinutes(),
      increment: increment,
      boundaries: [0, 59]
    }));
  }

  if (type === 'seconds') {
    result.setSeconds(shiftTime({
      value: value.getSeconds(),
      increment: increment,
      boundaries: [0, 59]
    }));
  }

  if (type === 'milliseconds') {
    result.setMilliseconds(shiftTime({
      value: value.getMilliseconds(),
      increment: increment,
      boundaries: [0, 999]
    }));
  }

  if (type === 'ampm' && isAmPm) {
    result.setHours(value.getHours() > 11 ? value.getHours() - 12 : value.getHours() + 12);
  }

  return result;
};

exports.getChangedTime = getChangedTime;

var checkForTimeFormat = function checkForTimeFormat(localeFormat) {
  var timeFormat = localeFormat.timeFormat;
  return {
    isAmPm: timeFormat.indexOf('h') !== -1 || timeFormat.indexOf('hh') !== -1,
    hourStartsWithZero: timeFormat.indexOf('H') !== -1 || timeFormat.indexOf('HH') !== -1
  };
};

exports.checkForTimeFormat = checkForTimeFormat;

var getChangedInputTime = function getChangedInputTime(_ref4) {
  var value = _ref4.value,
      type = _ref4.type,
      newValue = _ref4.newValue,
      localeFormat = _ref4.localeFormat;
  var result = new Date(value);
  var parsedValue = parseInt(newValue, 10);

  var _checkForTimeFormat2 = checkForTimeFormat(localeFormat),
      isAmPm = _checkForTimeFormat2.isAmPm,
      hourStartsWithZero = _checkForTimeFormat2.hourStartsWithZero;

  if (type === 'ampm') {
    return null;
  }

  if (!isNaN(parsedValue)) {
    var hourBoundaries = hourStartsWithZero ? [0, 23] : [1, 24];

    if (isAmPm) {
      hourBoundaries = [1, 12];
    }

    if (type === 'hours' && parsedValue >= hourBoundaries[0] && parsedValue <= hourBoundaries[1]) {
      result.setHours(parsedValue);
    }

    if (type === 'minutes' && parsedValue >= 0 && parsedValue <= 59) {
      result.setMinutes(parsedValue);
    }

    if (type === 'seconds' && parsedValue >= 0 && parsedValue <= 59) {
      result.setSeconds(parsedValue);
    }

    if (type === 'milliseconds' && parsedValue >= 0 && parsedValue <= 999) {
      result.setMilliseconds(parsedValue);
    }

    return result;
  }

  return null;
};

exports.getChangedInputTime = getChangedInputTime;
//# sourceMappingURL=utils.js.map